import { Home } from '@mui/icons-material'
import React, { useEffect } from 'react'
import { Outlet } from 'react-router-dom'

import Footer from '../../features/Core/Footer/Footer'
import HeaderHome from '../../features/Core/Header/HomeHeader'
import { initSocket } from './SocketInstance'


 function Dashboard() {

  useEffect(() => {
    const userJSON = sessionStorage.getItem("userDetails");
    // let userid = null;

    if (userJSON) {
      const user = JSON.parse(userJSON);
      if (user && user.user_id) {
        initSocket(user.user_id);
      }
    } else {
      console.log("User Id cannot available in session storage");
    }
  }, []);

  // dashboard for layout 

  return (
    <div className="container-fluid p-0">
      <HeaderHome />
      <Outlet />
      <Footer />
    </div>
  );
}

export default Dashboard;
